(function () {
  var PRODUCT_SECTION_SELECTOR = '[data-section-type="product-page"]';
  var FORM_SELECTOR = 'form[data-product-id]';
  var ACTIVE_CLASS = 'divetia-variant-media-active';
  var SHARED_PACKAGING_ALT_PREFIX = 'DIVETIA shared packaging —';
  var MANAGED_ATTRIBUTE = 'data-divetia-variant-media-managed';
  var MANAGED_STYLE_ID = 'divetia-variant-media-managed-style';
  var initializedProducts = {};

  function toNumber(value) {
    var number = Number(value);
    return Number.isFinite(number) ? number : null;
  }

  function getProductData(form) {
    if (!form || !window._themeProducts) return null;
    return window._themeProducts[form.dataset.productId] || null;
  }

  function getSelectedVariant(form) {
    var product = getProductData(form);
    var variantIdInput = form && form.querySelector('[name="id"]');
    var variantId = toNumber(variantIdInput && variantIdInput.value);
    if (!product || !variantId || !Array.isArray(product.variants)) return null;
    return product.variants.find(function (variant) {
      return Number(variant.id) === variantId;
    }) || null;
  }

  function mediaSrc(media) {
    if (!media) return '';
    if (typeof media === 'string') return media;
    return media.src || (media.preview_image && media.preview_image.src) || '';
  }

  function normalizeSrc(src) {
    return String(src || '')
      .replace(/^https?:/, '')
      .replace(/_\d+x(?=\.(jpg|jpeg|png|webp))/i, '')
      .split('?')[0];
  }

  function normalizeStoneText(value) {
    return String(value || '')
      .toLowerCase()
      .replace(/\bdiamonds\b/g, 'diamond');
  }

  function variantMediaIndex(product, variant) {
    if (!variant) return null;
    var media = variant.featured_media;
    var position = toNumber(media && media.position);
    if (position) return position - 1;

    var src = normalizeSrc(mediaSrc(variant.featured_image) || mediaSrc(media));
    if (!src || !Array.isArray(product && product.media)) return null;

    for (var index = 0; index < product.media.length; index += 1) {
      if (normalizeSrc(mediaSrc(product.media[index])) === src) return index;
    }

    return null;
  }

  function variantStoneToken(variant) {
    var values = [variant && variant.title];
    if (variant && Array.isArray(variant.options)) values = values.concat(variant.options);
    var text = normalizeStoneText(values.filter(Boolean).join(' '));
    if (text.indexOf('pink diamond') !== -1) return 'pink diamond';
    if (text.indexOf('white diamond') !== -1) return 'white diamond';
    if (text.indexOf('sapphire') !== -1) return 'sapphire';
    return '';
  }

  function isImageMedia(media) {
    return !media || !media.media_type || media.media_type === 'image';
  }

  function mediaRolePriority(media) {
    var alt = String((media && media.alt) || '').toLowerCase();
    if (alt.indexOf('front view') !== -1) return 0;
    if (alt.indexOf('angle') !== -1) return 1;
    if (alt.indexOf('charm with lab-grown') !== -1) return 0;
    if (alt.indexOf('styled') !== -1 || alt.indexOf('worn') !== -1) return 2;
    return 3;
  }

  function isCharmVariantGallery(product, variant) {
    var handle = String((product && product.handle) || '');
    return /^(blossom|bound|daisy-day|endless|flutter|paw-promise)-/.test(handle) &&
      Boolean(variantStoneToken(variant));
  }

  function exactVariantMediaOrder(media, token, goldOrder) {
    var matching = [];
    media.forEach(function (item, index) {
      if (isSharedPackagingMedia(item)) return;
      var alt = normalizeStoneText((item && item.alt) || '');
      if (alt.indexOf(token) !== -1) matching.push(index);
    });

    var ordered = [];
    function addFirst(predicate) {
      var match = matching.find(function (index) {
        return ordered.indexOf(index) === -1 && predicate(media[index], normalizeStoneText(media[index].alt || ''));
      });
      if (match !== undefined) ordered.push(match);
      return match !== undefined;
    }

    // Keep this in lockstep with snippets/divetia-variant-media-order.liquid.
    // Shane 2510: Sapphire view with the Nov 2 silver studio shot follows the gold gallery
    // pattern: studio shot, worn, motion video, group/gift box, front, angle, remaining.
    // Shane 2526: designs whose studio shot is held for regen (product.dv_sapphire_gold_order
    // without a dv_studio media entry) keep the same order without the studio slot.
    var studioIndex = token === 'sapphire' ? matching.find(function (index) {
      return Boolean(media[index] && media[index].dv_studio);
    }) : undefined;
    if (studioIndex !== undefined || (token === 'sapphire' && goldOrder)) {
      if (studioIndex !== undefined) ordered.push(studioIndex);
      addFirst(function (item, alt) {
        return isImageMedia(item) && alt.indexOf('styled on') !== -1;
      });
      addFirst(function (item, alt) {
        return item && item.media_type === 'video' && alt.indexOf('styled motion view') !== -1;
      });
      addFirst(function (item, alt) {
        return isImageMedia(item) && (alt.indexOf('presented in') !== -1 || alt.indexOf('multi-charm') !== -1);
      });
      addFirst(function (item, alt) {
        return isImageMedia(item) && alt.indexOf('front view') !== -1;
      });
      addFirst(function (item, alt) {
        return isImageMedia(item) && alt.indexOf('angle') !== -1;
      });
      matching.forEach(function (index) {
        if (ordered.indexOf(index) === -1) ordered.push(index);
      });
      return ordered;
    }
    addFirst(function (item, alt) {
      return isImageMedia(item) && alt.indexOf('styled on') !== -1;
    });
    addFirst(function (item, alt) {
      return item && item.media_type === 'video' && alt.indexOf('styled motion view') !== -1;
    });
    var hasExplicitSecondary = addFirst(function (item, alt) {
      return isImageMedia(item) && (alt.indexOf('lifestyle') !== -1 || alt.indexOf('presented in') !== -1);
    });
    if (!hasExplicitSecondary) {
      addFirst(function (item, alt) {
        return isImageMedia(item) &&
          alt.indexOf('front view') === -1 &&
          alt.indexOf('angle') === -1 &&
          alt.indexOf('charm with lab-grown') === -1;
      });
    }
    addFirst(function (item, alt) {
      return isImageMedia(item) && alt.indexOf('front view') !== -1;
    });
    addFirst(function (item, alt) {
      return isImageMedia(item) &&
        alt.indexOf('styled on') === -1 &&
        alt.indexOf('lifestyle') === -1 &&
        alt.indexOf('presented in') === -1 &&
        alt.indexOf('angle') === -1;
    });
    addFirst(function (item, alt) {
      return isImageMedia(item) && alt.indexOf('angle') !== -1;
    });

    matching.forEach(function (index) {
      if (ordered.indexOf(index) === -1) ordered.push(index);
    });
    return ordered;
  }

  function isSharedPackagingMedia(media) {
    var alt = String((media && media.alt) || '');
    return alt.indexOf(SHARED_PACKAGING_ALT_PREFIX) === 0;
  }

  function sharedPackagingMediaIndex(media) {
    for (var index = 0; index < media.length; index += 1) {
      if (isSharedPackagingMedia(media[index])) return index;
    }
    return null;
  }

  function injectManagedStyle() {
    if (document.getElementById && document.getElementById(MANAGED_STYLE_ID)) return;
    if (!document.createElement || !document.head) return;
    var style = document.createElement('style');
    style.id = MANAGED_STYLE_ID;
    style.textContent =
      '[' + MANAGED_ATTRIBUTE + '="true"] .sf-prod-media-item:not(.' + ACTIVE_CLASS + ')' +
      '{display:none!important;}' +
      '[' + MANAGED_ATTRIBUTE + '="true"] .divetia-shared-packaging-media img' +
      '{object-fit:cover!important;object-position:center 33.333%!important;}' +
      '[' + MANAGED_ATTRIBUTE + '="true"] .divetia-shared-packaging-media .sf-prod-media,' +
      '[' + MANAGED_ATTRIBUTE + '="true"] .divetia-shared-packaging-media .sf-image' +
      '{--aspect-ratio:0.9!important;}';
    document.head.appendChild(style);
  }

  function fallbackMediaIndexes(product, variant, media, sharedIndex) {
    var fallback = variantMediaIndex(product, variant);

    if (fallback === null || fallback === sharedIndex) {
      fallback = null;
      for (var index = 0; index < media.length; index += 1) {
        if (!isSharedPackagingMedia(media[index])) {
          fallback = index;
          break;
        }
      }
    }

    if (fallback === null) return [];
    var indexes = [fallback];
    if (sharedIndex !== null && sharedIndex !== fallback) indexes.push(sharedIndex);
    return indexes;
  }

  function variantMediaIndexes(product, variant) {
    var token = variantStoneToken(variant);
    var media = Array.isArray(product && product.media) ? product.media : [];
    if (!media.length) return [];

    var sharedIndex = sharedPackagingMediaIndex(media);
    if (!token) {
      if (sharedIndex === null) return fallbackMediaIndexes(product, variant, media, sharedIndex);
      var defaultIndexes = media.map(function (_item, index) { return index; })
        .filter(function (index) { return !isSharedPackagingMedia(media[index]); });
      if (defaultIndexes.length) defaultIndexes.push(sharedIndex);
      return defaultIndexes;
    }

    var orderedIndexes;
    if (isCharmVariantGallery(product, variant)) {
      orderedIndexes = exactVariantMediaOrder(media, token, Boolean(product && product.dv_sapphire_gold_order));
    } else {
      var prioritized = [];
      media.forEach(function (item, index) {
        if (isSharedPackagingMedia(item)) return;
        var alt = normalizeStoneText((item && item.alt) || '');
        if (alt.indexOf(token) !== -1) {
          prioritized.push({ index: index, priority: mediaRolePriority(item) });
        }
      });
      prioritized.sort(function (left, right) {
        if (left.priority !== right.priority) return left.priority - right.priority;
        return left.index - right.index;
      });
      orderedIndexes = prioritized.map(function (item) { return item.index; });
    }
    if (!orderedIndexes.length) return fallbackMediaIndexes(product, variant, media, sharedIndex);
    if (sharedIndex !== null) orderedIndexes.push(sharedIndex);
    return orderedIndexes;
  }

  function syncSwiper(swiperContainer, index, managed) {
    if (!swiperContainer || index === null) return;
    var swiper = swiperContainer.swiper;
    if (!swiper) return;
    try {
      if (typeof swiper.update === 'function') swiper.update();
      if (managed) {
        if (swiper.params && swiper.params.loop && typeof swiper.slideToLoop === 'function') {
          swiper.slideToLoop(0, 250);
        } else if (typeof swiper.slideTo === 'function') {
          swiper.slideTo(0, 250);
        }
        return;
      }
      var slides = Array.prototype.slice.call(swiper.slides || []);
      var exactSlide = slides.find(function (slide) {
        return !slide.classList.contains('swiper-slide-duplicate') &&
          Number(slide.dataset.index) === index;
      });
      if (exactSlide && typeof swiper.slideTo === 'function') {
        swiper.slideTo(slides.indexOf(exactSlide), 250);
        return;
      }
      if (swiper.params && swiper.params.loop && typeof swiper.slideToLoop === 'function') {
        swiper.slideToLoop(index, 250);
      } else if (typeof swiper.slideTo === 'function') {
        swiper.slideTo(index, 250);
      }
    } catch (error) {
      console.warn('DIVETIA variant media swiper sync failed', error);
    }
  }

  function isRenderedGalleryLayout(mediaItem) {
    var layout = mediaItem && mediaItem.closest && mediaItem.closest(
      '.sf-product-media__mobile, .sf-product-media__desktop'
    );
    if (!layout || typeof window.getComputedStyle !== 'function') return false;
    var style = window.getComputedStyle(layout);
    return style.display !== 'none' && style.visibility !== 'hidden';
  }

  function videoPlayer(video) {
    if (!video) return null;
    if (video.plyr) return video.plyr;
    var wrapper = video.closest && video.closest('.media-video');
    return wrapper && wrapper.plyr ? wrapper.plyr : video;
  }

  function pauseVideo(video) {
    var player = videoPlayer(video);
    if (player && typeof player.pause === 'function') player.pause();
  }

  function resumeAutoplayVideo(video) {
    var isMuted = Boolean(video && (
      video.muted || video.defaultMuted ||
      (video.hasAttribute && video.hasAttribute('muted'))
    ));
    var wantsAutoplay = Boolean(video && (
      video.autoplay || (video.hasAttribute && video.hasAttribute('autoplay'))
    ));
    if (!isMuted || !wantsAutoplay) return;
    var player = videoPlayer(video);
    if (!player || typeof player.play !== 'function') return;
    try {
      var result = player.play();
      if (result && typeof result.catch === 'function') result.catch(function () {});
    } catch (_error) {}
  }

  function markActiveMedia(section, indexes, pauseInactiveVideos) {
    section.querySelectorAll('.sf-prod-media-item').forEach(function (mediaItem) {
      var active = indexes.indexOf(Number(mediaItem.dataset.index)) !== -1;
      var wasActive = mediaItem.classList.contains(ACTIVE_CLASS);
      var resumeNewActive = pauseInactiveVideos && active && !wasActive &&
        isRenderedGalleryLayout(mediaItem);
      mediaItem.classList.toggle(ACTIVE_CLASS, active);
      if (pauseInactiveVideos && mediaItem.querySelectorAll) {
        mediaItem.querySelectorAll('video').forEach(function (video) {
          if (!active) pauseVideo(video);
          else if (resumeNewActive) resumeAutoplayVideo(video);
        });
      }
    });
  }

  function lightboxElement(media) {
    if (!media) return null;
    if (media.media_type === 'image') return { href: media.src, type: 'image' };
    if (media.media_type === 'video') {
      var sources = Array.isArray(media.sources) ? media.sources : [];
      var source = sources.find(function (item) {
        var url = String((item && item.url) || '');
        var format = String((item && item.format) || '').toLowerCase();
        var mimeType = String((item && (item.mime_type || item.mimeType)) || '').toLowerCase();
        return format === 'mp4' || mimeType === 'video/mp4' || /\.mp4(?:[?#]|$)/i.test(url);
      });
      var href = source && String(source.url || '').replace(/[?#].*$/, '');
      return href ? { href: href, type: 'video' } : null;
    }
    if (media.media_type === 'external_video') {
      var href = media.host === 'youtube'
        ? 'https://www.youtube.com/watch?v=' + media.external_id + '&gl=true'
        : media.host === 'vimeo'
          ? 'https://vimeo.com/' + media.external_id
          : '';
      return href ? { href: href, type: 'video', source: media.host } : null;
    }
    return null;
  }

  function productInstance(form, product) {
    if (typeof window._getProductInstances !== 'function' || !product) return null;
    var instances = window._getProductInstances(product.id) || [];
    return instances.find(function (instance) {
      return instance && instance.productForm === form;
    }) || instances[0] || null;
  }

  function syncLightbox(form, product, indexes) {
    var instance = productInstance(form, product);
    var helper = instance && instance.productHelper;
    if (!helper || !helper.lightbox || typeof helper.lightbox.setElements !== 'function') return null;
    var lightboxIndexes = indexes.filter(function (index) {
      return Boolean(lightboxElement(product.media[index]));
    });
    var elements = lightboxIndexes.map(function (index) {
      return lightboxElement(product.media[index]);
    });
    helper.lightbox.setElements(elements);
    helper._divetiaLightboxIndexes = lightboxIndexes;
    return helper;
  }

  function moveDesktopMediaGroupFirst(section, indexes) {
    var desktopList = section.querySelector('.sf-product-media__desktop .flex-grow');
    if (!desktopList || !indexes.length) return;
    for (var offset = indexes.length - 1; offset >= 0; offset -= 1) {
      var mediaItem = desktopList.querySelector(
        '.sf-prod-media-item[data-index="' + indexes[offset] + '"]'
      );
      if (mediaItem) desktopList.insertBefore(mediaItem, desktopList.firstElementChild);
    }
  }

  function moveSwiperMediaGroupFirst(swiperContainer, indexes) {
    if (!swiperContainer || !indexes.length) return;
    var swiper = swiperContainer.swiper;
    var rebuildLoop = Boolean(
      swiper && swiper.params && swiper.params.loop &&
      typeof swiper.loopDestroy === 'function' && typeof swiper.loopCreate === 'function'
    );
    if (rebuildLoop) swiper.loopDestroy();
    var wrapper = swiperContainer.querySelector && swiperContainer.querySelector('.swiper-wrapper');
    if (!wrapper) {
      if (rebuildLoop) swiper.loopCreate();
      return;
    }
    for (var offset = indexes.length - 1; offset >= 0; offset -= 1) {
      var slide = wrapper.querySelector(
        '.sf-prod-media-item[data-index="' + indexes[offset] + '"]:not(.swiper-slide-duplicate)'
      );
      if (slide) wrapper.insertBefore(slide, wrapper.firstElementChild);
    }
    if (rebuildLoop) swiper.loopCreate();
  }

  function syncVariantMedia(form, variant) {
    var product = getProductData(form);
    var selectedVariant = variant || getSelectedVariant(form);
    var section = form && form.closest(PRODUCT_SECTION_SELECTOR);
    var indexes = variantMediaIndexes(product, selectedVariant);
    var firstIndex = indexes.length ? indexes[0] : null;
    if (!section || firstIndex === null) return;

    var isManaged = isCharmVariantGallery(product, selectedVariant);
    if (isManaged) {
      injectManagedStyle();
      section.setAttribute(MANAGED_ATTRIBUTE, 'true');
      section._divetiaVariantMediaIndexes = indexes.slice();
      var packagingIndex = sharedPackagingMediaIndex(product.media);
      section.querySelectorAll('.sf-prod-media-item').forEach(function (item) {
        item.classList.toggle('divetia-shared-packaging-media', Number(item.dataset.index) === packagingIndex);
      });
    }

    markActiveMedia(section, indexes, isManaged);
    moveDesktopMediaGroupFirst(section, indexes);

    var mobile = section.querySelector('.sf-product-media__mobile .swiper-container');
    var mobileNav = section.querySelector('.sf-media-nav-mobile .swiper-container, .nav-swiper-container-mobile');
    var desktop = section.querySelector('.sf-product-media__desktop .swiper-container');
    var desktopNav = section.querySelector('.sf-media-nav .swiper-container, .nav-swiper-container');
    var reorderMedia = isManaged;
    if (reorderMedia) {
      moveSwiperMediaGroupFirst(mobile, indexes);
      moveSwiperMediaGroupFirst(mobileNav, indexes);
      moveSwiperMediaGroupFirst(desktop, indexes);
      moveSwiperMediaGroupFirst(desktopNav, indexes);
    }

    syncSwiper(mobile, firstIndex, reorderMedia);
    syncSwiper(mobileNav, firstIndex, reorderMedia);
    syncSwiper(desktop, firstIndex, reorderMedia);
    syncSwiper(desktopNav, firstIndex, reorderMedia);
    if (reorderMedia) syncLightbox(form, product, indexes);
  }

  function openManagedLightbox(event) {
    var mediaItem = event.target && event.target.closest && event.target.closest('.sf-prod-media-item');
    var section = mediaItem && mediaItem.closest && mediaItem.closest(PRODUCT_SECTION_SELECTOR);
    if (!section || section.getAttribute(MANAGED_ATTRIBUTE) !== 'true') return;

    var isImage = mediaItem.classList.contains('media-type-image');
    var isZoom = event.target.closest && event.target.closest('.sf-prod-media__zoom-in');
    if (!isImage && !isZoom) return;

    var form = section.querySelector(FORM_SELECTOR);
    var product = getProductData(form);
    var indexes = section._divetiaVariantMediaIndexes || [];
    var helper = syncLightbox(form, product, indexes);
    var filteredIndex = helper && helper._divetiaLightboxIndexes
      ? helper._divetiaLightboxIndexes.indexOf(Number(mediaItem.dataset.index))
      : -1;
    if (!helper) return;

    event.preventDefault();
    event.stopImmediatePropagation();
    if (helper.currPlayer && typeof helper.currPlayer.pause === 'function') helper.currPlayer.pause();
    helper.lightbox.openAt(filteredIndex);
  }

  function syncFromEventTarget(target) {
    var form = target && target.closest && target.closest(FORM_SELECTOR);
    if (!form) return;
    window.setTimeout(function () {
      syncVariantMedia(form);
    }, 80);
    window.setTimeout(function () {
      syncVariantMedia(form);
    }, 260);
  }

  function subscribeProductEvents() {
    if (!window.MinimogEvents || !window._themeProducts) return;
    Object.keys(window._themeProducts).forEach(function (productId) {
      if (initializedProducts[productId]) return;
      initializedProducts[productId] = true;
      window.MinimogEvents.subscribe(productId + '__VARIANT_CHANGE', function (variant, productInstance) {
        var form = productInstance && productInstance.productForm;
        if (form) syncVariantMedia(form, variant);
      });
    });
  }

  function initialSync() {
    document.querySelectorAll(FORM_SELECTOR).forEach(function (form) {
      syncVariantMedia(form);
    });
  }

  function boot() {
    subscribeProductEvents();
    initialSync();
  }

  document.addEventListener('change', function (event) {
    syncFromEventTarget(event.target);
  }, true);

  document.addEventListener('click', function (event) {
    if (event.target && event.target.closest && event.target.closest('.product-option-item')) {
      syncFromEventTarget(event.target);
    }
  }, true);

  document.addEventListener('click', openManagedLightbox, true);

  document.addEventListener('DOMContentLoaded', boot);
  document.addEventListener('shopify:section:load', function () {
    window.setTimeout(boot, 100);
  });
  window.setTimeout(boot, 700);

  window.DivetiaVariantMediaSwitch = {
    sync: initialSync,
    mediaIndexes: variantMediaIndexes
  };
})();
